<template>
  <div
    v-if="showWarning"
    class="vue-cookie-warning fixed left-0 bottom-0 right-0 z-50 p-3 pr-7 bg-white text-black drop-shadow-top text-center"
    @click="accept"
  >
    <div class="mx-auto flex items-center justify-center gap-5">
      <p class="max-w-[600px]">
        We use our own and third-party tracking technologies, including cookies, to collect and share information on this website. See our
        <a
          href="/pages/privacy"
          class="font-bold underline"
        >
          Privacy Policy
        </a>
        for details.
      </p>
      <button
        class="hidden lg:block button small"
        @click="accept"
      >
        Close
      </button>
    </div>
    <CloseButton
      class="absolute top-1 right-1 shadow-md"
      @click="accept"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useBreakpoints } from '@/plugins/global'
import Cookies from 'js-cookie'
import { CloseButton } from '@oatsovernight/storybook'

const { md } = useBreakpoints()
const showWarning = ref(!Cookies.get('allow-cookies'))

const accept = () => {
  // if (window.Shopify) {
  //   window.Shopify.customerPrivacy.setTrackingConsent(true, () => {
  //     showWarning.value = false
  //   })
  // }
  showWarning.value = false
  Cookies.set('allow-cookies', new Date().toJSON(), { path: '', expires: 365 })
}

const handleBannerRemoveEvent = () => {
  document.removeEventListener('click', handleBannerRemoveEvent)
  document.removeEventListener('scroll', handleBannerRemoveEvent)
  accept()
}

// const init = () => {
//   const { customerPrivacy }  = window.Shopify
//   const userCanBeTracked = customerPrivacy.userCanBeTracked()
//   const userTrackingConsent = customerPrivacy.getTrackingConsent()
//   if (!userCanBeTracked && userTrackingConsent === 'no_interaction') {
//     showWarning.value = true
//   }
// }

// if (window.Shopify) {
//   window.Shopify.loadFeatures([{
//     name: 'consent-tracking-api',
//     version: '0.1'
//   }], (error) => {
//     if (error) {
//       console.warn(error)
//     }
//     init()
//   })
// } else {
//   showWarning.value = true
// }

document.addEventListener('click', handleBannerRemoveEvent)
if (md.value) {
  document.addEventListener('scroll', handleBannerRemoveEvent)
}
setTimeout(accept, 10000)
</script>

<style>
.ab__hide-cookie-warning .vue-cookie-warning {
  display: none;
}
</style>
